import { field, formatEther, parseEther, readContract, writeContractAndWait } from "../viem";
import MafiaCarCrusherAbi from "../../abis/MafiaCarCrusher.json";
import config from "../../config/config";

const address = config.carCrusherAddress;
const abi = MafiaCarCrusherAbi;

export const crushCars = async (
  account: string,
  itemIds: number[],
  message: string,
  signature: string
) => {
  const tx = await writeContractAndWait({
    address,
    abi,
    functionName: "crushCars",
    args: [itemIds, JSON.stringify(message), signature],
    account,
  });
  return tx.transactionHash;
};

export const claimCityProfit = async (account: string, cityId: number) => {
  const tx = await writeContractAndWait({
    address,
    abi,
    functionName: "claimCityProfit",
    args: [cityId],
    account,
  });
  return tx.transactionHash;
};

export const updateCityCrusherSettings = async (
  account: string,
  cityId: number,
  bulletFeePerCar: number,
  oneTimeCashFee: number
) => {
  const bulletFeeWei = parseEther(bulletFeePerCar.toString());
  const cashFeeWei = parseEther(oneTimeCashFee.toString());
  const tx = await writeContractAndWait({
    address,
    abi,
    functionName: "updateCityCrusherSettings",
    args: [cityId, bulletFeeWei, cashFeeWei],
    account,
  });
  return tx.transactionHash;
};

export const getCityCrusherInfo = async (cityId: number) => {
  const info: any = await readContract({
    address,
    abi,
    functionName: "cityCrusherInfo",
    args: [cityId],
  });

  return {
    inventoryItemId: Number(field(info, "inventoryItemId", 2)),
    lastUpdateTime: Number(field(info, "lastUpdateTime", 5)),
    bulletProfit: Number(formatEther(field(info, "bulletProfit", 0))),
    cashProfit: Number(formatEther(field(info, "cashProfit", 1))),
    bulletFeePerCar: Number(formatEther(field(info, "bulletFeePerCar", 3))),
    oneTimeCashFee: Number(formatEther(field(info, "oneTimeCashFee", 4))),
  };
};

export const getNextCrushTime = async (account: string) => {
  const nextCrushTime: number = await readContract({
    address,
    abi,
    functionName: "nextCrushTime",
    args: [account],
  });
  return Number(nextCrushTime);
};
